module.exports = __webpack_public_path__ + "static/logo_avalingua-190436aae474219c3307143244edadc4.png";